const namespace = 'user';

export const GET_USER_OWN_PROFILE = `${namespace}/GET_USER_OWN_PROFILE`;
export const SUBMIT_JOIN_REQUEST = `${namespace}/SUBMIT_JOIN_REQUEST`;
export const GET_USER_MYSELF = `${namespace}/GET_USER_MYSELF`;
export const DEACTIVATE_USER = `${namespace}/DEACTIVATE_USER`;
export const UPDATE_USER_PROFILE = `${namespace}/UPDATE_USER_PROFILE`;
export const GET_USER_COMMISSION_SETTINGS = `${namespace}/GET_USER_COMMISSION_SETTINGS`;
